module.exports = __webpack_public_path__ + "images/2f35ed17e85341317f60c6f0cadff46d.png";